import { createContext } from 'react';

export interface I18nContextValue {
  lang: string;
  setLang: (lang: string) => Promise<void>;
  t: (key: string, params?: Record<string, string | number>) => string;
  toggleLang: () => void;
}

export const LanguageContext = createContext<I18nContextValue | null>(null);
